module.exports = __webpack_public_path__ + "static/media/cart_check.e31f179e.svg";